import React from 'react';
import { connect } from 'react-redux';
import {
    X,
    ArrowLeft,
    RefreshCw,
    FileText,
    HelpCircle,
    LogOut,
    Trash2,
    Edit,
    Monitor,
    ChevronDown,
    Menu as HamburgerMenu,
} from 'react-feather';
import './UserDropDown.css';
import determineNameDisplay, { userInitials } from '../../../shared/utils/RenderNameUtil/RenderNameUtil';
import { disguise } from '../../../shared/utils/AwesomeAdminUtil/AwesomeAdminUtil';
import { testID } from '../../../shared/utils/integrationTesting/integrationTesting';
import { navTestId } from '../../../constants/testIds';
import { translate } from '../../../shared/translations';
import {
    H5,
    navItems,
    Paragraph1,
    sanitizePropertyValue,
} from '../../../shared/theme/styles';
import Dropdown from '../../../shared/components/Dropdown/Dropdown';
import { anchorMap, MobileNavOptions } from '../NavOptions/NavOptions';
import {
    setDropdownOpenAction,
    setDropdownCloseAction,
    setLogoutUserAction,
    refreshDataAction,
    changeLanguageAction,
} from '../../../actions/actionCreators';
import { setDesktopMode } from '../../../shared/utils/MobileDetector/MobileDetector';
import Avatar from '../../../shared/components/Avatar/Avatar';

export class UserDropDown extends React.Component {
    dropdownID = 'hamburgerMenuDropdown';

    dropdownOptions = [
        {
            id: 'user-label',
            shouldShowCheck: () => true,
            builder: () => ({
                ...testID(navTestId.userDropDownUserLabel),
                key: 'user-label',
                text: this.userLabel(this.props.isMobile),
                onClick: () => { window.location.href = `/user/edit/${this.props.user.MVID}`; },
            }),
        },
        {
            id: 'mobile-nav-options',
            shouldShowCheck: () => this.props.isMobile,
            builder: () => (MobileNavOptions(this.props.navigationOptions)),
        },
        {
            id: 'admin-control',
            shouldShowCheck: () => this.props.adminOptions.length,
            builder: () => ({
                key: 'admin-options',
                text: (
                    <div className="admin-control">
                        <div className="admin-control-title control" style={H5}>{translate('admin_settings')}</div>
                        <div className="user-dropdown-control-container">
                            {this.props.adminOptions.map(anchorMap)}
                        </div>
                    </div>
                ),
            }),
        },
        {
            id: 'disguise-control',
            shouldShowCheck: () => this.props.user.isSuperAdmin,
            builder: () => ({
                key: 'disguise-options',
                text: (
                    <div className="disguise-control">
                        <div className="disguise-control-title control" style={H5}>{translate('disguise')}</div>
                        <div className="user-dropdown-control-container">
                            <a
                                {...testID(navTestId.disguiseOptionsUser)}
                                key="user-disguise"
                                role="button"
                                tabIndex={0}
                                style={navItems}
                                onClick={() => disguise()}
                            >
                                {translate('disguise_as_user')}
                            </a>
                            <a
                                {...testID(navTestId.disguiseOptionsAdmin)}
                                key="user-disguise"
                                role="button"
                                tabIndex={0}
                                style={navItems}
                                onClick={() => disguise('ADMIN')}
                            >
                                {translate('disguise_as_admin')}
                            </a>
                        </div>
                    </div>
                ),
            }),
        },
        {
            id: 'user-dropdown-divider-thin',
            shouldShowCheck: () => true,
            builder: () => ({ type: 'divider-thin' }),
        },
        {
            id: 'user-dropdown-language-selector',
            shouldShowCheck: () => this.props.user.availableLanguages.length > 1,
            builder: () => ({
                key: 'language-selector',
                text: (
                    <div className="language-selector">
                        <div className="language-selector-title control">{translate('language')}</div>
                        {this.englishFirst(this.props.user.availableLanguages).map((language) => (
                            <div>
                                <input
                                    {...testID(navTestId.userDropDownLanguageSelector + language.Locale)}
                                    key={`${language.Locale}-lang`}
                                    id={`${language.Locale}-lang`}
                                    type="radio"
                                    checked={language.Selected}
                                    name="language-selector"
                                    onClick={() => this.props.changeLanguage(language.Locale)}
                                />
                                <label htmlFor={`${language.Locale}-lang`}>
                                    {language.DisplayName}
                                </label>
                            </div>
                        ))}
                    </div>
                ),
            }),
        },
        {
            id: 'user-dropdown-divider',
            shouldShowCheck: () => true,
            builder: () => ({ type: 'divider' }),
        },
        {
            id: 'user-dropdown-admin-return',
            shouldShowCheck: () => !this.props.user.isSuperAdmin && this.props.user.isThiefsDownfall,
            builder: () => ({
                ...testID(navTestId.userDropDownAdminReturn),
                key: 'admin-return',
                text: (this.dropdownItemText('admin_return')),
                icon: (<ArrowLeft color={sanitizePropertyValue('--gray-500')} size={24} />),
                leftIcon: true,
                onClick: () => { window.location.href = '/?ThiefsDownfall=true'; },
            }),
        },
        {
            id: 'user-dropdown-clear-cache',
            shouldShowCheck: () => this.props.user.isSuperAdmin || this.props.user.isThiefsDownfall,
            builder: () => ({
                ...testID(navTestId.userDropDownClearCache),
                key: 'clear-cache',
                text: (this.dropdownItemText('clear_cache')),
                icon: (<Trash2 color={sanitizePropertyValue('--gray-500')} size={24} />),
                leftIcon: true,
                onClick: () => { window.location.href = '/ca/clear_session_cache/'; },
            }),
        },
        {
            id: 'user-dropdown-edit-superadmins',
            shouldShowCheck: () => this.props.user.isSuperAdmin && !this.props.user.isThiefsDownfall && this.props.user.entityID && !this.props.isMobile,
            builder: () => ({
                ...testID(navTestId.userDropDownEditSuperAdmins),
                key: 'edit-superadmins',
                text: (this.dropdownItemText('edit_super_admins')),
                icon: (<Edit color={sanitizePropertyValue('--gray-500')} size={24} />),
                leftIcon: true,
                onClick: () => { window.location.href = `/entities/edit/${this.props.user.entityID}`; },
            }),
        },
        {
            id: 'user-dropdown-refresh-data',
            shouldShowCheck: () => this.props.user.isAdmin,
            builder: () => ({
                ...testID(navTestId.userDropDownRefreshData),
                key: 'refresh-data',
                text: (this.dropdownItemText('refresh_data')),
                icon: (<RefreshCw color={sanitizePropertyValue('--gray-500')} size={24} />),
                leftIcon: true,
                onClick: this.props.refreshData,
            }),
        },
        {
            id: 'user-dropdown-desktop',
            shouldShowCheck: () => this.props.isMobile,
            builder: () => ({
                ...testID(navTestId.userDropDownGoToDesktop),
                key: 'desktop',
                text: (this.dropdownItemText('go_to_desktop')),
                icon: (<Monitor color={sanitizePropertyValue('--gray-500')} size={24} />),
                leftIcon: true,
                onClick: () => {
                    setDesktopMode();
                    this.props.setDropdownClose();
                    window.dispatchEvent(new Event('resize'));
                },
            }),
        },
        {
            id: 'user-dropdown-help-menus',
            shouldShowCheck: () => this.props.user.helpMenus.length > 0,
            builder: () => (
                this.props.user.helpMenus.map((helpMenu, index) => ({
                    ...testID(navTestId.userDropDownHelpMenu + index),
                    key: `${helpMenu.linkText}`,
                    text: (this.dropdownItemText(helpMenu.linkText)),
                    icon: (this.helpMenuIconMap(helpMenu.linkURL)),
                    leftIcon: true,
                    onClick: () => { window.open(helpMenu.linkURL, helpMenu.linkTarget); },
                }))
            ),
        },
        {
            id: 'user-dropdown-logout',
            shouldShowCheck: () => true,
            builder: () => ({
                ...testID(navTestId.userDropDownLogout),
                key: 'logout',
                text: (this.dropdownItemText('logout')),
                icon: (<LogOut color={sanitizePropertyValue('--gray-500')} size={24} />),
                leftIcon: true,
                onClick: () => { window.location.href = '/logout/'; },
            }),
        },
    ];

    isActive = () => (this.props.dropdownOpenId === this.dropdownID && this.props.dropdownOpen);

    hamburgerMenuIcon = () => (<HamburgerMenu color={sanitizePropertyValue('--primaryBackground')} />);

    userLabel = (showUserIcon) => (
        <div className="UserLabel">
            {showUserIcon && (
                <Avatar
                    initials={userInitials(this.props.user.firstName, this.props.user.lastName)}
                    showIndicator
                    classOverride="UserIcon"
                    topNav
                />
            )}
            <div className="UserName">
                {determineNameDisplay(this.props.user.firstName, this.props.user.lastName, true)}
                {showUserIcon ? null : <span style={Paragraph1} className="link-hint">{`(${translate('profile')})`}</span>}
            </div>
            {showUserIcon ? <ChevronDown className="dropdownIcon rotateOnOpen" alt="Dropdown icon" strokeWidth="4px" size="16px" /> : null}
        </div>
    )

    dropdownItemText = (text) => (<span className="selectedActionText" style={Paragraph1}>{translate(text)}</span>)

    englishFirst = (langs) => {
        const index = langs.findIndex((lang) => lang.Locale === 'en');
        return [
            langs[index],
            ...langs.slice(0, index),
            ...langs.slice(index + 1),
        ];
    }

    helpMenuIconMap = (helpMenu) => {
        if (helpMenu === '/apidocs/') {
            return (<FileText color={sanitizePropertyValue('--gray-500')} size={24} />);
        }
        return (<HelpCircle color={sanitizePropertyValue('--gray-500')} size={24} />);
    }

    getDropdownOptions = () => {
        const outputDDOptions = [];
        this.dropdownOptions
            .filter((ddOption) => ddOption.shouldShowCheck())
            .forEach((ddOption) => {
                const mappedOption = ddOption.builder();
                if (Array.isArray(mappedOption)) {
                    outputDDOptions.push(...mappedOption);
                } else {
                    outputDDOptions.push(mappedOption);
                }
            });

        return outputDDOptions;
    }

    mobileRender = () => (
        <Dropdown
            {...testID(navTestId.userDropDownMobile)}
            popup
            id={this.dropdownID}
            options={this.getDropdownOptions()}
            icon={this.hamburgerMenuIcon()}
            isActive={this.isActive()}
            className="mobileView"
            dropdownType="dropdownAction"
            dropdownButtonStyle="menu"
            onOpen={(event, data) => { this.props.setDropdownOpen(data.id); }}
            onClose={this.props.setDropdownClose}
            toggleClose={<X size={18} style={{ verticalAlign: 'middle' }} />}
            position="topLeft"
        />
    );

    desktopRender = () => (
        <Dropdown
            {...testID(navTestId.userDropDownDesktop)}
            id={this.dropdownID}
            dropdownType="dropdownAction"
            dropdownButtonStyle="menu"
            options={this.getDropdownOptions()}
            icon={this.userLabel(true)}
            isActive={this.isActive()}
            onOpen={(event, data) => { this.props.setDropdownOpen(data.id); }}
            onClose={this.props.setDropdownClose}
            toggleClose={<X size={18} style={{ verticalAlign: 'middle' }} />}
            position="topRight"
        />
    )

    render() {
        return this.props.isMobile ? this.mobileRender() : this.desktopRender();
    }
}

/* istanbul ignore next */
const mapStateToProps = (state) => ({
    adminOptions: state.navigationOptions.admin,
    dropdownOpen: state.dropdown.dropdownOpen,
    dropdownOpenId: state.dropdown.dropdownOpenId,
    navigationOptions: state.navigationOptions.header,
    user: state.userInfo,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    setDropdownOpen: (dropdownOpenId) => dispatch(setDropdownOpenAction(dropdownOpenId)),
    setDropdownClose: () => dispatch(setDropdownCloseAction()),
    logoutUser: () => dispatch(setLogoutUserAction()),
    changeLanguage: (language) => dispatch(changeLanguageAction(language)),
    refreshData: () => dispatch(refreshDataAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDropDown);
